import { render } from "./Checkbox.vue?vue&type=template&id=36c7c73a&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=36c7c73a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c7c73a"]])

export default __exports__